/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionAbort';

const ActionAbortManager: ActionManagerFn<'ActionAbort'> = (
  platform: Platform,
): ActionManager<'ActionAbort'> => {
  return {
    ...baseActionManager(platform, 'ActionAbort'),
    defaultValue,
    props: {
      ...baseActionProps,
      message: {
        label: 'Message',
        type: 'expression',
        returnType: async () => 'string',
        required: true,
      },
    },
    name: 'Abort Remaining Actions',
    getDisplayText: (item) => item.props.message.value,
    description: `Use this action to conditionally abort the processing of further actions. If a message is give, it will be displayed as an Error message to the user.

> e.g. Use this before a Save action to prevent saving if a business condition/validation is not met`,
  };
};

export default ActionAbortManager;
